import { render, staticRenderFns } from "./ediPort.vue?vue&type=template&id=60e88f2d&"
import script from "./ediPort.vue?vue&type=script&lang=js&"
export * from "./ediPort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e88f2d')) {
      api.createRecord('60e88f2d', component.options)
    } else {
      api.reload('60e88f2d', component.options)
    }
    module.hot.accept("./ediPort.vue?vue&type=template&id=60e88f2d&", function () {
      api.rerender('60e88f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/ediPort.vue"
export default component.exports